import React from 'react';

export function OptionButton ({
  onClick,
  iconImgSrc,
  label
} : {
  onClick?: React.DOMAttributes<HTMLButtonElement>["onClick"],
  iconImgSrc?: string,
  label: string
}) {
  return (
    <button
      className="flex gap-6 items-center text-lg py-2 px-4 bg-gray-100 text-gray-500 font-medium rounded w-full"
      onClick={onClick}
    >
      {iconImgSrc ? <img src={iconImgSrc} width="18px" height="18px" /> : null}
      <span>{label}</span>
    </button>
  )
}
